import { render, staticRenderFns } from "./likeMe.vue?vue&type=template&id=f526fde4&"
import script from "./likeMe.vue?vue&type=script&lang=js&"
export * from "./likeMe.vue?vue&type=script&lang=js&"
import style0 from "./likeMe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports